// extracted by mini-css-extract-plugin
module.exports = {"heart":"style_heart__12CI2","example":"style_example__zSmjf"};